import type { MedicalCaseData, MedicalCaseUpdateParams } from 'chaika-frontend-types/frontend-cms';

import { MutableData } from '@store/abstract/MutableData';

export interface MedicalCaseMutableDataParams extends Pick<
    MedicalCaseData,
    keyof Omit<MedicalCaseUpdateParams, 'entryId'>
> {
    shareLink?: string;
}

export class MedicalCaseMutableData extends MutableData<MedicalCaseMutableDataParams> {
    public readonly mutableKeys: (keyof MedicalCaseMutableDataParams)[] = [
        'managerId',
        'name',
        'description',
        'closeComment',
        'shareLink',
        'isReferralsRequired',
    ];

    protected numbersFields = new Set([]);

    constructor(data: MedicalCaseMutableDataParams) {
        super();
        this.init(data);
    }

    public get isValid(): boolean {
        const serialized = this.serialize();

        return !!serialized;
    }
}
